import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useIntl } from 'react-intl';
import { removeSnackbar } from '../../actions/Notifications';

let displayed = [];

const NotificationSnackbar = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const snackbars = useSelector((store) => store.notifications.snackbars || []);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const currentLocale = useSelector((state) => state.app?.locale?.locale);

  const storeDisplayed = (id) => {
    displayed = [...displayed, id];
  };

  const removeDisplayed = (id) => {
    displayed = [...displayed.filter((key) => id !== key)];
  };

  useEffect(() => {
    snackbars.forEach((snackbar) => {
      const {
        key, message, messageKey, messageValues, options = {}, dismissed = false,
      } = snackbar;
      if (dismissed) {
        closeSnackbar(key);
        return;
      }

      if (displayed.includes(key)) return;

      // Translate message if messageKey is provided, otherwise use message as is
      const translatedMessage = messageKey
        ? intl.formatMessage({ id: messageKey }, messageValues || {})
        : message;

      enqueueSnackbar(translatedMessage, {
        key,
        ...options,
        onClose: (event, reason, myKey) => {
          if (options.onClose) {
            options.onClose(event, reason, myKey);
          }
        },
        onExited: (event, myKey) => {
          dispatch(removeSnackbar(myKey));
          removeDisplayed(myKey);
        },
      });

      storeDisplayed(key);
    });
  }, [snackbars, closeSnackbar, enqueueSnackbar, dispatch, intl, currentLocale]);

  return null;
};

export default NotificationSnackbar;
